import React from 'react';
import styles from './css/ThankYou.styl';
import _ from 'lodash';
import classnames from 'classnames';
import {
  FlowerIcon,
  ThankYouEmailIcon,
  CloseXIcon,
} from '../../../../shared/Svgs';
import {
  HandleShareClick,
  ShareIcons,
} from '../../../../shared/utilities/shareHelpers';
import {getName} from '../../../../../appModules/utilities/formatHelpers';
import {FormControls} from '../../../../shared/library';
const {Button} = FormControls;

const flowers = require('./assets/flowers@2x.jpg');

const ThankYou = props => {
  const {
    canonicalUrl,
    entry,
    flowerClickEvents,
    flowersLink,
    flowersLocation,
    handleClose,
    handleFlowersImgLoad,
    name,
    showFlowers,
    title,
  } = props;

  const {firstname = '', lastname = ''} = entry || {};
  const first = firstname ? ` ${firstname}` : '';
  const last = lastname ? ` ${lastname}` : '';
  const hasFlowersLocation = _.get(flowersLocation, 'sourceId', false);
  let funeralHomeBlock = null;

  const shareIcons = ShareIcons(canonicalUrl, title);

  if (hasFlowersLocation) {
    const {
      name: flowersName,
      address1,
      address2,
      city,
      state,
      postalCode,
    } = flowersLocation;

    funeralHomeBlock = (
      <div>
        <p className={styles.funeralHome}>{flowersName}</p>
        <p id="address1">{address1}</p>
        {address2 && <p id="address2">{address2}</p>}
        <p id="address3">
          {city} {state}, {postalCode}
        </p>
      </div>
    );
  }

  return (
    <div className={styles.ThankYou}>
      <div className={classnames(styles.module, styles.message)}>
        <div className={styles.close} onClick={handleClose}>
          <CloseXIcon />
        </div>
        <ThankYouEmailIcon />
        <p className={styles.header}>Thank You{`${first}${last}`}</p>
        <p className={styles.body}>
          Please allow <span>24 hours</span> for your entry to be reviewed for
          appropriate content.
        </p>
      </div>
      {showFlowers ? (
        <div className={classnames(styles.module, styles.flowers)}>
          <p className={styles.header}>Would you like to send flowers?</p>
          <img onLoad={handleFlowersImgLoad} src={flowers} />
          {funeralHomeBlock}
          {flowersLink ? (
            <a
              className={styles.link}
              data-ga-no-auto-tag="true"
              href={flowersLink}
              onClick={flowerClickEvents}
              tabIndex="1000"
              target="_blank"
            >
              <span>
                <FlowerIcon />
              </span>
              Send Flowers &rsaquo;
            </a>
          ) : null}
        </div>
      ) : null}
      <div className={classnames(styles.module, styles.shares)}>
        <p>
          Invite family & friends to share the life of{' '}
          <span>{getName(name)}</span>
        </p>
        <div className={styles.group}>
          {shareIcons.map((obj, i) => (
            <Button
              btnType="none"
              className={styles.icon}
              handleClick={_.partial(
                HandleShareClick,
                _,
                obj.shareUrl,
                obj.label
              )}
              id={obj.label}
              key={i}
            >
              <span className={styles[obj.label]}>{obj.svg}</span>
            </Button>
          ))}
        </div>
      </div>
      <div className={classnames(styles.module, styles.buttonContainer)}>
        <Button className={styles.button} handleClick={handleClose}>
          No Thanks
        </Button>
      </div>
    </div>
  );
};

ThankYou.propTypes = {
  canonicalUrl: React.PropTypes.string,
  entry: React.PropTypes.object,
  flowerClickEvents: React.PropTypes.func,
  flowersLink: React.PropTypes.string,
  flowersLocation: React.PropTypes.object,
  handleClose: React.PropTypes.func,
  handleFlowersImgLoad: React.PropTypes.func,
  name: React.PropTypes.object,
  showFlowers: React.PropTypes.bool,
  title: React.PropTypes.string,
};

export default ThankYou;



// WEBPACK FOOTER //
// ./src/reactModules/pages/Person/components/GuestBook/ThankYou.js